import React, { useEffect, useState } from "react";
import imgEdit from "../../../assets/siteManagement/images/edit.svg";
import imgPin from "../../../assets/siteManagement/images/pin-2.svg";
import { useTranslation } from "react-i18next";
import DefaultImageCard from "../images/defaultImageCard.png";
import { useParams } from "react-router-dom";
import Edit2Icon from "src/components/site_management/icons/Edit2Icon";

function SiteBoxDetailType3(props) {
  const { lang } = useParams();
  const { t } = useTranslation("settings");
  const [detailSite, setDetailSite] = useState({
    Id: null,
    Name: "",
    Description: "",
    Location: "",
    Image: null,
    ListImage: [],
  });

  const isEdit = props.onClickEdit ? true : false;

  useEffect(() => {
    if (props.detailSite) {
      let detail = {
        ...props.detailSite,
      };
      setDetailSite(detail);
    }
  }, [props.detailSite]);

  function onClickEditSite() {
    try {
      props.onClickEdit(detailSite);
    } catch {}
  }

  const getDetailSiteName = detailSite?.Name.includes('"name_english"')
    ? JSON.parse(detailSite?.Name)
    : detailSite?.Name;

  const detailSiteName =
    typeof getDetailSiteName === "string"
      ? getDetailSiteName
      : lang === "th"
      ? getDetailSiteName?.name_thai
      : getDetailSiteName?.name_english;

  return (
    <div className="w-full h-full p-2 bg-white rounded-lg shadow-content-box">
      <div className="w-full h-[100px] flex">
        <div className="w-[100px] h-[100px] rounded-lg bg-vekin-primary/30 overflow-hidden">
          {detailSite?.Image?.includes("data:") ? (
            <img
              className="w-full h-full object-cover"
              src={DefaultImageCard}
              alt="default-image-card"
            />
          ) : (
            <img
              className="w-full h-full object-cover"
              src={detailSite.Image}
              alt="image-card"
            />
          )}
        </div>
        <div className="h-full pl-4" style={{ width: "calc(100% - 100px)" }}>
          <div className="w-full h-[36px] flex items-center">
            <p
              className="pr-2 overflow-hidden text-lg font-bold text-vekin-primary text-ellipsis whitespace-nowrap"
              style={{ width: "calc(100% - 12px)" }}
              title={detailSiteName}
            >
              {detailSiteName}
            </p>
            {isEdit && (
              // <img
              //   className="w-[12px] h-[12px] cursor-pointer hover:opacity-50 duration-300 ease-in-out"
              //   src={imgEdit}
              //   alt=""
              //   onClick={(e) => {
              //     onClickEditSite();
              //   }}
              // />
              <Edit2Icon className="w-[12px] h-[12px] cursor-pointer hover:opacity-50 duration-300 ease-in-out"
              onClick={(e) => {
                onClickEditSite();
              }}
              />
            )}
          </div>
          <div
            className="overflow-y-auto"
            style={{ height: "calc(100% - 36px)" }}
          >
            <p className="text-xs font-normal leading-tight text-secondary">
              {detailSite?.Description.includes("null") ||
              detailSite?.Description.includes("undefined")
                ? " "
                : detailSite?.Description}
            </p>
          </div>
        </div>
      </div>

      <div className="w-full h-px my-2 bg-quartenary"></div>

      <div className="w-full" style={{ height: "calc(100% - 117px)" }}>
        <div className="w-full h-[16px]">
          <p className="text-tertiary text-[10px] font-semibold">
            {`${t("site_management.location")} :`}
          </p>
        </div>
        <div className="flex w-full" style={{ height: "calc(100% - 16px)" }}>
          <div
            className="h-full pr-2 overflow-y-auto"
            style={{ width: "calc(100% - 40px)" }}
          >
            <p className="text-xs font-normal text-primary">
              {detailSite?.Location || ""}
            </p>
          </div>
          <div className="w-[40px] h-full flex items-center">
            <div className="w-[40px] h-[40px] rounded-lg bg-vekin-green-50 flex justify-center items-center">
              <img className="w-3 h-4" src={imgPin} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SiteBoxDetailType3;
